import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import POSService from '../../core/services/POSService'
import alertify from 'alertifyjs'
const AddCustomerModal = ({ setCustomers, loadOptionsCustomers, handleAddCustomer }) => {
  const { t } = useTranslation()

  const [newCustomerForm, setNewCustomerForm] = useState({
    name: '',
    email: '',
    phone: '',
    contact_address_inline: '',
  })

  const [errors, setErrors] = useState({
    name: false,
    phone: false,
  })

  const handleChange = (e) => {
    const { name, value } = e.target

    setNewCustomerForm((prev) => ({ ...prev, [name]: value }))

    // Clear error when user starts typing
    if (name === 'name' || name === 'phone') {
      setErrors((prev) => ({ ...prev, [name]: false }))
    }
  }

  const validateForm = () => {
    const nameError = !newCustomerForm.name.trim()
    const phoneError = !newCustomerForm.phone.trim()

    setErrors({
      name: nameError,
      phone: phoneError,
    })

    return !(nameError || phoneError)
  }

  const handleSubmit = async () => {
    // Validate form before submission
    if (!validateForm()) {
      alertify.error('Lỗi khi nhập thông tin khách hàng')
      return
    }

    try {
      const res = await POSService.createCustomer(newCustomerForm)
      let newCustomer = {
        value: res[0],
        label: `${newCustomerForm.name} - ${newCustomerForm.phone}`,
      }
      const fetchedCustomerData = await loadOptionsCustomers()
      setCustomers(fetchedCustomerData)
      handleAddCustomer(newCustomer)

      // Reset form after successful submission
      setNewCustomerForm({
        name: '',
        email: '',
        phone: '',
        contact_address_inline: '',
      })
    } catch (error) {
      console.error('Error creating customer:', error)
      // Optionally handle error (show message to user)
    }
  }

  return (
    <div className='modal fade' id='create-new-customer' tabIndex={-1} aria-labelledby='create' aria-hidden='true'>
      <div className='modal-dialog modal-lg modal-dialog-centered' role='document'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{t('add_customer')}</h5>
            <button type='button' className='close' data-bs-dismiss='modal' aria-label='Close'>
              <span aria-hidden='true'>×</span>
            </button>
          </div>
          <div className='modal-body'>
            <form>
              <div className='row'>
                <div className='col-lg-6 col-sm-12 col-12'>
                  <div className='input-blocks'>
                    <label className='text-black'>
                      {t('customer_name')} <span className='text-danger'>*</span>
                    </label>
                    <input
                      style={{ color: 'black', borderColor: errors.name ? 'red' : '' }}
                      type='text'
                      name='name'
                      className='form-control'
                      value={newCustomerForm.name}
                      onChange={handleChange}
                      required
                    />
                    {errors.name && <small className='text-danger'>{t('name_is_required')}</small>}
                  </div>
                </div>
                <div className='col-lg-6 col-sm-12 col-12'>
                  <div className='input-blocks'>
                    <label className='text-black'>
                      {t('phone')} <span className='text-danger'>*</span>
                    </label>
                    <input
                      style={{ color: 'black', borderColor: errors.phone ? 'red' : '' }}
                      type='text'
                      name='phone'
                      className='form-control'
                      value={newCustomerForm.phone}
                      onChange={handleChange}
                      required
                    />
                    {errors.phone && <small className='text-danger'>{t('phone_is_required')}</small>}
                  </div>
                </div>

                <div className='col-lg-6 col-sm-12 col-12'>
                  <div className='input-blocks'>
                    <label className='text-black'>Email</label>
                    <input
                      style={{ color: 'black' }}
                      type='email'
                      name='email'
                      className='form-control'
                      value={newCustomerForm.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='col-lg-6 col-sm-12 col-12'>
                  <div className='input-blocks'>
                    <label className='text-black'>{t('address')}</label>
                    <input
                      style={{ color: 'black' }}
                      type='text'
                      name='contact_address_inline'
                      className='form-control'
                      value={newCustomerForm.contact_address_inline}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className='modal-footer d-sm-flex justify-content-end'>
                <Link
                  to='#'
                  className='btn btn-submit me-2'
                  data-bs-dismiss='modal'
                  onClick={(e) => {
                    e.preventDefault()
                    handleSubmit()
                  }}
                >
                  {t('save')}
                </Link>
                <button type='button' className='btn btn-cancel' data-bs-dismiss='modal'>
                  {t('cancel')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCustomerModal
